import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateMomentAdapter } from './util/datepicker-adapter';
import { NewssoappSharedLibsModule } from './';
import { TranslateDirective } from "./language/translate.directive";

@NgModule({
    imports: [NewssoappSharedLibsModule],
    declarations: [TranslateDirective],
    providers: [{ provide: NgbDateAdapter, useClass: NgbDateMomentAdapter }],
    entryComponents: [],
    exports: [TranslateDirective],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NewssoappSharedModule {
    static forRoot() {
        return {
            ngModule: NewssoappSharedModule
        };
    }
}
